import React from "react";
import { AppBar, Container, Toolbar } from "@mui/material";
import logo from "../../assets/images/logo-tiny2_2.png";

export const TopBar = () => {
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <img src={logo} />
        </Toolbar>
      </Container>
    </AppBar>
  );
};
